import { BulkUploadTypes, UploadTypeConfig, uploadTypeConfigMap } from 'constants/bulkUpload';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';
import useReduxSelector from 'utils/useReduxSelector';
import { useHistory } from 'react-router-dom';

export const useBulkUploadTypeConfig = (bulkUploadType: BulkUploadTypes): UploadTypeConfig => {
  const isRxCurrentAccountMerchant = !!useReduxSelector(
    loggedInUserSelectors.currentOrganization,
  )?.isRxCurrentAccountMerchant;
  const featureFlags = useReduxSelector(loggedInUserSelectors.features);
  const history = useHistory();

  const uploadTypeConfig = uploadTypeConfigMap[bulkUploadType]?.({ isRxCurrentAccountMerchant, featureFlags, history });

  return uploadTypeConfig;
};
